module.exports = __webpack_public_path__ + "img/McD_Standorte_Fullscreenimages_01.3d0ce6bc.jpg";